import { FontAwesomeIcon } from '@magoosh/lib/icons';
import React from 'react';

export const Spinner = () => (
  <div className="text-center u-margin-T-l">
    <FontAwesomeIcon icon="spinner" className="fa-pulse fa-5x" />
  </div>
);
